<div class="campaign-read-more-modal" *ngIf="isOpen" (click)="closeModal()">
  <article class="campaign-detail-modal" (click)="$event.stopPropagation()">
    <div class="campaign-detail-modal__hero" *ngIf="campaign?.imageUrl">
      <img [src]="campaign?.imageUrl" [alt]="name" />
      <button
        type="button"
        class="campaign-detail-modal__close"
        (click)="closeModal()"
        [attr.aria-label]="'CAMPAIGN.Close' | translate"
      >
        ×
      </button>
    </div>

    <div class="campaign-detail-modal__content">
      <div class="campaign-detail-modal__title-wrap">
        <h3 class="campaign-detail-modal__title">{{ name }}</h3>
        <span class="campaign-detail-modal__divider" aria-hidden="true"></span>
      </div>

      <div class="campaign-detail-modal__tagline" *ngIf="detailTagline">{{ detailTagline }}</div>

      <div class="campaign-detail-modal__body" *ngIf="detailBody">
        <p>{{ detailBody }}</p>
      </div>

      <div class="campaign-detail-modal__list" *ngIf="detailActions.length && detailListIntro">
        <p class="campaign-detail-modal__list-intro">{{ detailListIntro }}</p>
        <ul>
          <li *ngFor="let action of detailActions">
            <strong *ngIf="action.label" class="campaign-detail-modal__label">{{ action.label }}:</strong>
            <span>{{ action.text }}</span>
          </li>
        </ul>
      </div>

      <p class="campaign-detail-modal__signoff" *ngIf="detailSignOff">{{ detailSignOff }}</p>
    </div>
  </article>
</div>
